module.exports = __webpack_public_path__ + "static/20210806_121340-6e898f2a95a9d650a80b6afda71521c4.jpg";